import { render, staticRenderFns } from "./CustomerManagementVisionChart.vue?vue&type=template&id=4382e907&scoped=true&"
import script from "./CustomerManagementVisionChart.vue?vue&type=script&lang=js&"
export * from "./CustomerManagementVisionChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4382e907",
  null
  
)

export default component.exports